/* tslint:disable */
/* eslint-disable */
/**
 * Logistics
 * 物流管理用API
 *
 * The version of the OpenAPI document: 1.0
 * Contact: kiuchi@wcdi.co.jp
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { CostcoProduct } from './CostcoProduct';
import {
    CostcoProductFromJSON,
    CostcoProductFromJSONTyped,
    CostcoProductToJSON,
} from './CostcoProduct';

/**
 * 
 * @export
 * @interface GetCostcoProduct200ResponseAllOfData
 */
export interface GetCostcoProduct200ResponseAllOfData {
    /**
     * 
     * @type {CostcoProduct}
     * @memberof GetCostcoProduct200ResponseAllOfData
     */
    costcoProduct: CostcoProduct;
}

/**
 * Check if a given object implements the GetCostcoProduct200ResponseAllOfData interface.
 */
export function instanceOfGetCostcoProduct200ResponseAllOfData(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "costcoProduct" in value;

    return isInstance;
}

export function GetCostcoProduct200ResponseAllOfDataFromJSON(json: any): GetCostcoProduct200ResponseAllOfData {
    return GetCostcoProduct200ResponseAllOfDataFromJSONTyped(json, false);
}

export function GetCostcoProduct200ResponseAllOfDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetCostcoProduct200ResponseAllOfData {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'costcoProduct': CostcoProductFromJSON(json['costco_product']),
    };
}

export function GetCostcoProduct200ResponseAllOfDataToJSON(value?: GetCostcoProduct200ResponseAllOfData | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'costco_product': CostcoProductToJSON(value.costcoProduct),
    };
}

